<template>
  <!-- 一个照片盒子 没有留白 -->
  <div class="id_15 clear">
    <div class="img_box" :class="{'cursor': data.url && data.radio !== 2}" @click="toPage(1)">
<!--      | imageFormat-->
      <img ref="img" v-lazy="data.src">
      <div class="btn" :style="btnStyle" @click="toPage(2)" v-if="data.url">
        {{$t('flowActive14')}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {
    }
  },
  computed: {
    /** 学生端强制手型；过滤后台编辑态残留的 cursor/z-index */
    btnStyle () {
      const raw = this.data.style || ''
      const cleaned = String(raw)
        .replace(/cursor\s*:[^;]+;?/gi, '')
        .replace(/z-index\s*:[^;]+;?/gi, '')
      return cleaned + ';cursor:pointer;'
    }
  },
  methods: {
    // 跳转
    toPage (num) {
      // if (this.data.url) window.open(this.data.url)
      console.log(this.data, 'data')
      if (num === 1 && +this.data.radio === 2) {
        return
      }
      console.log(this.data.url, 'this.data.url')
      if (this.data.url) window.open(this.data.url)
    }
  }
}
</script>

<style lang="scss" scoped>
// 后台配置区基准宽 936px，按钮 168×38；学生端按图片容器宽度等比缩放
$design-width: 936;
$btn-w: 168;
$btn-h: 38;
$btn-font: 16;
.id_15{
  word-wrap:break-word;
  width: 100%;
  font-size: 0;
  line-height: 0;
  .img_box{
    width: 100%;
    position: relative;
    container-type: inline-size;
    container-name: id15-img;
    img{
      width: 100%;
      display: block;
    }
    .btn {
      position: absolute;
      width: calc(#{$btn-w} / #{$design-width} * 100%);
      aspect-ratio: #{$btn-w} / #{$btn-h};
      height: auto;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: 1.2;
      font-size: #{'max(12px, calc(' + $btn-font + ' / ' + $design-width + ' * 100cqw))'};
      border-radius: 999px;
      font-family: OPPOSans-B, OPPOSans;
      font-weight: normal;
      color: #FFFFFF;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 #{'calc(8 / ' + $design-width + ' * 100cqw)'};
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/details/public/id_15.vue